import React from 'react'
import './access-policy-expanded-row-view.scss'
import { IAccessPolicy } from '@halo/interfaces/access-policy'
import JsonView from '@halo/components/json-view/json-view'
import { classnames } from '@halo/_utils/classnames'
import { Well } from '@pushly/aqe/lib/components'
import { Descriptions } from 'antd'

interface IRowViewProps {
    policy: IAccessPolicy
}

const AccessPolicyExpandedRowView: React.FunctionComponent<IRowViewProps> = ({ policy }) => {
    return (
        <div className={classnames('expanded-access-policy-view')}>
            <Well title="Policy Details" hideFooter={true}>
                <Descriptions layout="horizontal" column={1}>
                    <Descriptions.Item label="Name">
                        <span>{policy.name}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Description">
                        <span>{policy.description}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Enabled">
                        <span>{policy.is_active ? 'TRUE' : 'FALSE'}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Effect">
                        <span>{policy.effect}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Subjects">
                        <span>{policy.subjects.join(', ')}</span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Actions">
                        <span>{policy.actions.join(', ')}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label="Conditions">
                        {!policy.conditions ? 'None' : <JsonView data={policy.conditions} defaultExpanded={true} />}
                    </Descriptions.Item>
                </Descriptions>
            </Well>
        </div>
    )
}

export default AccessPolicyExpandedRowView
